/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Links_One_Per_LineInputs */

const en_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Links (one per line)`)
};

const es_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlaces de Video (uno por línea)`)
};

const fr_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liens Vidéo (un par ligne)`)
};

const de_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video-Links (einer pro Zeile)`)
};

const ja_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオリンク (1行に1つ)`)
};

const zh_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频链接 (每行一个)`)
};

const ar_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روابط الفيديو (رابط واحد لكل سطر)`)
};

const id_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan Video (satu per baris)`)
};

const it_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Video (uno per riga)`)
};

const ru_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылки на Видео (по одной в строке)`)
};

const pt_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links de Vídeo (um por linha)`)
};

const ko_video_links_one_per_line = /** @type {(inputs: Video_Links_One_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비디오 링크 (한 줄에 하나씩)`)
};

/**
* | output |
* | --- |
* | "Video Links (one per line)" |
*
* @param {Video_Links_One_Per_LineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const video_links_one_per_line = /** @type {((inputs?: Video_Links_One_Per_LineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Links_One_Per_LineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_video_links_one_per_line(inputs)
	if (locale === "es") return es_video_links_one_per_line(inputs)
	if (locale === "fr") return fr_video_links_one_per_line(inputs)
	if (locale === "de") return de_video_links_one_per_line(inputs)
	if (locale === "ja") return ja_video_links_one_per_line(inputs)
	if (locale === "zh") return zh_video_links_one_per_line(inputs)
	if (locale === "ar") return ar_video_links_one_per_line(inputs)
	if (locale === "id") return id_video_links_one_per_line(inputs)
	if (locale === "it") return it_video_links_one_per_line(inputs)
	if (locale === "ru") return ru_video_links_one_per_line(inputs)
	if (locale === "pt") return pt_video_links_one_per_line(inputs)
	return ko_video_links_one_per_line(inputs)
});